import React, { FC, memo } from 'react'

import { Babi } from '@interco/inter-ui/components/Babi'

export const CustomBabi: FC = memo(() => <Babi origin="PRIVACY_POLICIES" />)
